import { Component, ElementRef, Host, HostListener, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ReportItemWithVisibility } from '@app/workflow/components/report-card/report-filter.service';
import { IReportItemCategory, ReportViewConfig } from '@interfaces/interfaces';
import { SessionItemData } from '../../services/session-item-data';

@Component({
	selector: 'workflow-report',
	templateUrl: './report.component.html',
	styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnChanges {

	@Input() reports: ReportItemWithVisibility[];
	@Input() data: SessionItemData;
	@Input() category: IReportItemCategory;
	public categoryVisibility: ReportViewConfig;
	public visibleReports: ReportItemWithVisibility[];
	
	public containerWidth: number;
	
	constructor(@Host() private readonly elementRef: ElementRef<HTMLElement>) {
		this.setSize();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.reports && this.reports) {
			this.visibleReports = this.reports.filter(report => this.category.entries.includes(report.id));
			this.categoryVisibility = {
				isVisible: this.visibleReports.some(report => report.visible),
				isPrintable: this.visibleReports.some(report => report.printable),
			};
		}
	}
	
	@HostListener('window:resize')
	private setSize() {
		this.containerWidth = this.elementRef.nativeElement.clientWidth;
	}
}
